import React from 'react'
import Campaign from './Campaign'

const DripCampaign = () => {
  return (
    <div>
      <Campaign />
    </div>
  )
}

export default DripCampaign